"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewAnimatePresence = void 0;
var _framerMotion = require("framer-motion");
// Workaround for React 18 no-implicit-children failure - https://github.com/framer/motion/issues/1509

const NewAnimatePresence = _framerMotion.AnimatePresence;
exports.NewAnimatePresence = NewAnimatePresence;